module.exports = __webpack_public_path__ + "assets/ec047c2ef228892c678625589ec1b6f4.mp3";